module.exports = __webpack_public_path__ + "img/client-9.0fbb2dee.png";